(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["charm-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    // Section IDs of every cart-items-component on the page (drawer + main cart).
    // Passing these to /cart/add lets Shopify return re-rendered section HTML so the
    // theme can morph the cart in place — the same flow product-form.js uses.
    function cartItemsSectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        var id = el.dataset.sectionId;
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      return ids;
    }

    var ADD_URL = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';

    document.querySelectorAll('.charm-bundle').forEach(function (root) {
      if (root.dataset.cbInit === '1') return;
      root.dataset.cbInit = '1';
      root.querySelectorAll('[data-charm-add]').forEach(function (btn) {
        var label = btn.querySelector('.charm-bundle__add-label');
        var original = label ? label.textContent : btn.textContent;
        function setText(t) { if (label) label.textContent = t; else btn.textContent = t; }
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          var vid = btn.dataset.variantId;
          if (!vid || btn.disabled) return;
          btn.disabled = true;
          setText('Adding...');

          var sectionIds = cartItemsSectionIds();
          var body = { items: [{ id: parseInt(vid, 10), quantity: 1 }] };
          if (sectionIds.length) body.sections = sectionIds.join(',');

          fetch(ADD_URL, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify(body)
          })
            .then(function (response) { if (!response.ok) throw new Error('cart_add_failed'); return response.json(); })
            .then(function (addResponse) {
              // Fetch the fresh cart so the event carries an accurate resource (item_count, etc.).
              return fetch('/cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  // ThemeEvents.cartUpdate === 'cart:update'. The cart drawer's CartAdd handler
                  // (opens drawer when auto-open) and every cart-items-component's update handler
                  // (morphs from detail.data.sections, or self-refetches if absent) both listen here.
                  document.dispatchEvent(new CustomEvent('cart:update', {
                    bubbles: true,
                    detail: {
                      resource: cart,
                      sourceId: 'charm-bundle',
                      data: {
                        source: 'charm-bundle',
                        sections: addResponse.sections,
                        itemCount: cart.item_count
                      }
                    }
                  }));
                });
            })
            .then(function () {
              setText('Added');
              btn.classList.add('is-added');
              setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); setText(original); }, 2000);
            })
            .catch(function () {
              setText('Try again');
              setTimeout(function () { btn.disabled = false; setText(original); }, 1800);
            });
        });
      });
    });
  })();

  (function () {
    document.querySelectorAll('[data-charm-more]').forEach(function (trigger) {
      var modal = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!modal || trigger.dataset.cmInit === '1') return;
      trigger.dataset.cmInit = '1';
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        var close = modal.querySelector('.charm-modal__close');
        if (close) close.focus();
      }
      function close() {
        modal.hidden = true;
        document.body.style.overflow = '';
        if (lastFocus) lastFocus.focus();
      }

      trigger.addEventListener('click', open);
      modal.querySelectorAll('[data-charm-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hidden) close();
      });
    });
  })();

  (function () {
    // The charm discount is a CODE (CHARMS35), not a second automatic discount.
    // Shopify applies only one automatic discount per order, so while the charm
    // offer was automatic it fought with "2nd bag 40% off" and one of the two
    // always lost. A code-class product discount combines with the automatic
    // BXGY instead. Verified on a live cart: Margot -22.78 from the 2nd-bag
    // discount and the charm -4.88 from CHARMS35, both in the same cart.
    var CODE = 'CHARMS35';
    var root = document.querySelector('.charm-bundle[data-charm-ids]');
    var CHARM_IDS = ((root && root.getAttribute('data-charm-ids')) || '')
      .split(',').map(Number).filter(Boolean);

    var busy = false;

    function ensureCode() {
      if (busy || !CHARM_IDS.length) return;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasCharm = (cart.items || []).some(function (i) {
            return CHARM_IDS.indexOf(i.product_id) !== -1;
          });
          if (!hasCharm) return;

          var codes = cart.discount_codes || [];
          var mine = codes.some(function (c) { return c.code === CODE; });
          // a shopper who typed their own code keeps it: outside Plus a cart
          // holds one code, so silently replacing theirs would be a downgrade
          var theirs = codes.some(function (c) { return c.code !== CODE && c.applicable; });
          if (mine || theirs) return;

          busy = true;
          fetch('/discount/' + CODE)
            .catch(function () {})
            .then(function () {
              busy = false;
              document.dispatchEvent(new CustomEvent('bynyla:charm-discount-applied'));
            });
        })
        .catch(function () { /* cart unreadable, leave the price alone */ });
    }

    ensureCode();
    document.addEventListener('cart:update', ensureCode);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["second-bag-promo"] && !Shopify.designMode) return;
  try {
    (function () {
    // Mirrors blocks/charm-bundle.liquid: pass the cart section ids to /cart/add so
    // the theme can morph the drawer in place instead of a full reload.
    function cartItemsSectionIds() {
      var ids = [];
      document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
        var id = el.dataset.sectionId;
        if (id && ids.indexOf(id) === -1) ids.push(id);
      });
      return ids;
    }
    var ADD_URL = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add';

    document.querySelectorAll('.second-bag-promo').forEach(function (root) {
      if (root.dataset.sbpInit === '1') return;
      root.dataset.sbpInit = '1';

      var toggle = root.querySelector('[data-sbp-toggle]');
      var panel = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
      if (toggle && panel) {
        toggle.addEventListener('click', function () {
          var open = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          panel.hidden = open;
        });
      }

      (panel || root).querySelectorAll('[data-sbp-add]').forEach(function (btn) {
        var label = btn.querySelector('.second-bag-promo__add-label');
        var original = label ? label.textContent : btn.textContent;
        function setText(t) { if (label) { label.textContent = t; } else { btn.textContent = t; } }

        // The price shown on each row is what the SECOND bag costs once the BXGY
        // discount lands, which only happens with two bags in the cart. Adding the
        // picked bag alone would charge full price, so the bag on this page goes in
        // with it - unless it is already in the cart, in which case adding it again
        // would just bump the quantity.
        function currentVariantId() {
          var form = document.querySelector('product-form-component form[action*="/cart/add"], form[action*="/cart/add"]');
          var input = form && form.querySelector('input[name="id"], select[name="id"]');
          var v = input && input.value;
          return v ? parseInt(v, 10) : null;
        }

        btn.addEventListener('click', function (event) {
          event.preventDefault();
          var vid = btn.dataset.variantId;
          if (!vid || btn.disabled) return;
          btn.disabled = true;
          setText('Adding...');

          var picked = parseInt(vid, 10);
          var mine = currentVariantId();

          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var inCart = {};
              (cart.items || []).forEach(function (i) { inCart[i.variant_id] = true; });
              var items = [];
              if (mine && mine !== picked && !inCart[mine]) items.push({ id: mine, quantity: 1 });
              items.push({ id: picked, quantity: 1 });

              var body = { items: items };
              var sectionIds = cartItemsSectionIds();
              if (sectionIds.length) body.sections = sectionIds.join(',');

              return fetch(ADD_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: JSON.stringify(body)
              });
            })
            .then(function (r) { if (!r.ok) throw new Error('cart_add_failed'); return r.json(); })
            .then(function (addResponse) {
              return fetch('/cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (cart) { return { cart: cart, sections: addResponse && addResponse.sections }; });
            })
            .then(function (res) {
              var cart = res.cart;
              document.dispatchEvent(new CustomEvent('cart:update', {
                detail: {
                  resource: cart,
                  // cart-icon.js reads event.detail.data.itemCount and defaults it to 0.
                  // Omitting it makes the badge render 0 even though the add succeeded.
                  // source must NOT be 'product-form-component' - that makes the icon ADD
                  // to the current count instead of setting the true total.
                  // sections is what cart-items-component morphs from; without it the
                  // drawer opens on stale markup and only fills after its own refetch.
                  data: { itemCount: cart.item_count, source: 'bynyla-upsell', sections: res.sections }
                },
                bubbles: true
              }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              setText('Added');
              setTimeout(function () { setText(original); btn.disabled = false; }, 1800);
            })
            .catch(function () { setText(original); btn.disabled = false; });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
